import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "pagination-buttons",
  templateUrl: "./pagination-buttons.component.html",
  styleUrls: [
    "./pagination-buttons.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class PaginationButtonsComponent {
  public _currentPage: number;
  public _totalPageCount: number;
  public _nextPage: number;

  @Input() loading: boolean;
  @Input() showNavBar: boolean = true;
  @Input() smallButtons: boolean = false;

  @Output() setPageTo = new EventEmitter<any>();

  @Input()
  set totalPageCount(totalPageCount: number) {
    this._totalPageCount = totalPageCount;
  }

  @Input()
  set currentPage(currentPage: number) {
    this._currentPage = currentPage;
  }

  ngOnInit() {
    this._nextPage = 0;
  }

  public broadCastPageButton(event: any) {
    // get id of clicked element
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.id;

    if (idAttr.nodeValue) {
      var value = idAttr.nodeValue;

      if (value === "btn-click-previous-pg" && this._currentPage !== 1) {
        {
          this._nextPage = this._currentPage - 1;
          this.setPageTo.emit(this._nextPage);
        }
      }
      if (
        value === "btn-click-next-pg" &&
        this._currentPage < this._totalPageCount
      ) {
        this._nextPage = this._currentPage + 1;
        this.setPageTo.emit(this._nextPage);
      }
    }
  }
}
